export default __webpack_public_path__ + "static/media/article.ef14080e.jpeg";